import {useRankedBrandTraits} from "./brand-traits";
import {useEffect, useState} from "react";
import {isNullOrUndefined} from "helpers/is-null-or-undefined";
import {httpsCallable} from "firebase/functions";
import {functions} from "hooks/firebase";
import {RecommendedColorsRequest, RecommendedColorsResponse} from "data/models/shared/recommended-colors";

export function useRecommendedColors():
    [RecommendedColorsResponse | null, boolean, Error | null] {
  const [rankedBrandTraits, rankedTraitsLoading, rankedTraitsError] = useRankedBrandTraits();
  const [error, setError] = useState<Error | null>(null);

  const [recommendedColors, setRecommendedColors] = useState<RecommendedColorsResponse | null>(null);

  const anError = (
      rankedTraitsError
  );

  const anyLoading = (
      rankedTraitsLoading
  )

  useEffect(() => {
    if (!isNullOrUndefined(anError)) {
      setError(anError);
      return;
    }
    if (
        anyLoading
    ) {
      return;
    }
    if (isNullOrUndefined(rankedBrandTraits)) {
      return;
    }

    const recommendedColorsRequest = {
      rankedBrandTraits: rankedBrandTraits?.slice(0, 2).map(trait => trait.traitKey),
    };

    const recommendedColorsFunction = httpsCallable<RecommendedColorsRequest, RecommendedColorsResponse>(functions, 'recommendedColors');

    recommendedColorsFunction(recommendedColorsRequest).then(result => {
      setRecommendedColors(result.data);
      setError(null);
    }).catch((error) => {
      setError(error as Error);
    });

  }, [
    rankedBrandTraits, anyLoading, anError,
  ]);

  return [recommendedColors, anyLoading, error];
}
